import ajax from '../../lib/appfuse-react/core/ajax';

export const settingService = {
  findMajorList: async () => {
    const response = await ajax.get("/setting/major/leaf", {}, {});
    return response.data;
  },
  getCitiesInTaiwan: async () => {
    const response = await ajax.get('/setting/address/cities', {}, {});
    return response.data;
  },

}